/**
 * PlatformSearchRepository — HTTP for the global platform search
 * (`/api/v2/search`).
 *
 * Methods return the raw AxiosResponse; callers read `.data`. Query-building
 * and result normalization live in `src/pages/home/composables/platformSearch.js`.
 */
import Client from '@/repositories/clients/AuthenticatedClient';

export default {
  /**
   * @param {{ q: string, types: string, limit: number, per_type_limit: number }} params
   * @returns {Promise<import('axios').AxiosResponse>}
   */
  search(params) {
    return Client.get('/search', { params });
  },
};
